export const GET_HAZARD_STATEMENT_AUTOCOMPLETE_LIST = 'GET_HAZARD_STATEMENT_AUTOCOMPLETE_LIST';
export const GET_HAZARD_STATEMENT_AUTOCOMPLETE_LIST_SUCCESS = `${GET_HAZARD_STATEMENT_AUTOCOMPLETE_LIST}/SUCCESS`;
export const GET_HAZARD_STATEMENT_AUTOCOMPLETE_LIST_FAILURE = `${GET_HAZARD_STATEMENT_AUTOCOMPLETE_LIST}/FAILURE`;

export const GET_EUH_STATEMENT_AUTOCOMPLETE_LIST = 'GET_EUH_STATEMENT_AUTOCOMPLETE_LIST';
export const GET_EUH_STATEMENT_AUTOCOMPLETE_LIST_SUCCESS = `${GET_EUH_STATEMENT_AUTOCOMPLETE_LIST}/SUCCESS`;
export const GET_EUH_STATEMENT_AUTOCOMPLETE_LIST_FAILURE = `${GET_EUH_STATEMENT_AUTOCOMPLETE_LIST}/FAILURE`;

GET_EUH_STATEMENT_AUTOCOMPLETE_LIST

export default {
  GET_HAZARD_STATEMENT_AUTOCOMPLETE_LIST,
  GET_HAZARD_STATEMENT_AUTOCOMPLETE_LIST_SUCCESS,
  GET_HAZARD_STATEMENT_AUTOCOMPLETE_LIST_FAILURE,
  GET_EUH_STATEMENT_AUTOCOMPLETE_LIST,
  GET_EUH_STATEMENT_AUTOCOMPLETE_LIST_FAILURE,
  GET_EUH_STATEMENT_AUTOCOMPLETE_LIST_SUCCESS
};
